export type CsvValue = string | number | boolean | null | undefined;

function escapeCsvValue(value: CsvValue): string {
  const text = String(value ?? "");
  const protectedText = /^\s*[=+\-@]/.test(text) ? `'${text}` : text;
  const escaped = protectedText.replace(/"/g, '""');
  return /[",\r\n]/.test(protectedText) ? `"${escaped}"` : escaped;
}

export function serializeCsv(
  headers: readonly string[],
  rows: readonly (readonly CsvValue[])[],
): string {
  return [headers, ...rows]
    .map((row) => row.map(escapeCsvValue).join(","))
    .join("\r\n");
}

export function sanitizeCsvFilenamePart(value: string): string {
  return (
    value
      .trim()
      .replace(/[^a-z0-9_-]+/gi, "-")
      .replace(/^-+|-+$/g, "") || "client"
  );
}

export function downloadCsv({
  filename,
  headers,
  rows,
}: {
  filename: string;
  headers: readonly string[];
  rows: readonly (readonly CsvValue[])[];
}) {
  const blob = new Blob([`\uFEFF${serializeCsv(headers, rows)}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
